import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreProductFilterService } from './point-store-product-filter.service';
import { PointStoreProductLandingService } from './point-store-product-landing.service';
import { PointStoreProductOrderService } from '../../agent-side/services/point-store-product-order.service';
import { PointStoreProductService } from './point-store-product.service';
import { PointStoreUtilityService } from './point-store-utility.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductEditService {

  LocalizationMarket: any = null;
  LocalizationMarketManMessages: any = null;
  pointStoreProductEditObj: any = {
    isSavingProduct: false,
    filterOpen: false,
    originalPointStoreProduct: null,
    modifiedPointStoreProduct: null,
    collection: {
      index: -1,
      isLoaded: false,
      isAssignmentLoaded: false,
      originalData: null,
      modifiedData: null,
      originalPointStoreProduct: null,
      modifiedPointStoreProduct: null,
      settingPointStoreProduct: null,
    },
    settingPointStoreProduct: null,
    landingPageView: null,
    pointStoreProductCSS: [
      { value: 0, name: "pointStoreImage carousel-product-sale-thumbnail active" },
      { value: 1, name: "pointStoreImage carousel-product-thumbnail active" },
      { value: 2, name: "pointStoreImage carousel-thumbnail active" },
      { value: 3, name: "pointStoreImage carousel-sale-thumbnail active" },

      { value: 4, name: "pointStoreImage product-sale-thumbnail active" },
      { value: 5, name: "pointStoreImage product-thumbnail active" },

      { value: 6, name: "pointStoreImage sale-thumbnail active" },

      { value: 7, name: "pointStoreImage carousel-product-thumbnail inactive" },
      { value: 8, name: "pointStoreImage sale-thumbnail inactive" },

      { value: 9, name: "pointStoreImage sort-double-arrow-icon" },
      { value: 10, name: "pointStoreImage sort-arrow-up-icon" },
      { value: 11, name: "pointStoreImage sort-arrow-down-icon" },
    ],
    sortReverse: null,
    sortBy: "",
    pointStoreProductSort: [
      { value: 0, sort: null, name: 'Title' },
      { value: 1, sort: null, name: 'Detail' },
      { value: 2, sort: null, name: 'Category' },
      { value: 3, sort: null, name: 'SubCategory' },
      { value: 4, sort: null, name: 'Price' },
      { value: 5, sort: null, name: 'Quantity' },
      { value: 6, sort: null, name: 'ProductStart' },
      { value: 7, sort: null, name: 'ProductEnd' },
      { value: 8, sort: null, name: 'ComputeSalePrice' },
      { value: 9, sort: null, name: 'QuantityOrdered' },
    ],
    pointStoreProductFilter: null,
    landingListToolbar: null,
    variationTypes: [
      "Types",
      "Colors",
      "Sizes"
    ],
    copiedProduct: false,
    variationTypesList: [],//cxone list
  };

  constructor(
    private pointStoreProductOrderService: PointStoreProductOrderService,
    private pointStoreProductService: PointStoreProductService,
    private pointStoreProductFilterService: PointStoreProductFilterService,
    private pointStoreProductLandingService: PointStoreProductLandingService,
    private cvLocalizationService: CVLocalizationService,
    private cvApiService: CVApiService,
    public config: CvConfigurationService,
    private pointStoreUtilityService: PointStoreUtilityService,
  ) {
    this.cvLocalizationService.GetSection("MarketPlace").then(
      (result) => {
        this.LocalizationMarket = result;
      }
    );
    this.cvLocalizationService.GetSection("MarketPlace_Management_Messages").then(
      (result) => {
        this.LocalizationMarketManMessages = result;
      }
    );
  }

  getIndexByProductIDFromOriginal(id) {
    let idx = -1;
    if (this.pointStoreProductEditObj.collection.originalData != null) {
      for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
        if (this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID == id) {
          idx = i;
          break;
        }
      }
    }
    return idx;
  }

  async loadPointStoreProduct() {
    try {
      // set setUpgLoad was removed from here to handle the loader in the front-end

      //to display only orders management loader
      if (this.pointStoreProductOrderService.pointStoreProductOrderObj.opc === '') {
        $("#upgLoad").hide();
      }

      const url = "/api/v2/marketplace/admin/products/";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data.filter((p) => { return p.Active; });
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Products: " + error.message);
    }
  }

  loadSettingPointStoreObject() {
    this.pointStoreProductEditObj.settingPointStoreProduct = this.pointStoreProductService.getNewPointStoreProductSetting();
    this.pointStoreProductEditObj.settingPointStoreProduct.Carousel = this.pointStoreProductEditObj.modifiedPointStoreProduct.IsCarouselChecked;
    this.pointStoreProductEditObj.settingPointStoreProduct.FeaturedProduct = this.pointStoreProductEditObj.modifiedPointStoreProduct.IsFeaturedChecked;
    this.pointStoreProductEditObj.settingPointStoreProduct.Sale = this.pointStoreProductEditObj.modifiedPointStoreProduct.IsOnSaleChecked;
  }

  syncPointStoreProductGroupListUpdate() {
    let assignments = this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductAssignments;
    if (assignments == null) { //no assignments. Set the control to be default. Add all groups back in if any are hidden                    
      this.glAddGroups();/*******????*****/
    } else if (assignments.length == 0) {
      this.glAddGroups();/*******????*****/
    } else {
      if (assignments.length == 1 && assignments[0].EmpGroupID == 0 && assignments[0].EmpGroupLevel == 5) { //All is selected
        this.glRemoveGroups();/*******????*****/
        this.pointStoreProductEditObj.modifiedPointStoreProduct.AssignedGroups = true; //checkbox binding
      }
      else {
        this.glAddGroups();/*******????*****/
        for (let i = 0; i < assignments.length; i++) {
          this.glRemoveGroup(assignments[i].EmpGroupID, assignments[i].EmpGroupLevel); /*******????*****/
        }
      }
    }
  }
  glAddGroups() { } /*******dummy*****/
  glRemoveGroup(d1, d2) { } /*******dummy*****/
  glRemoveGroups() { } /*******dummy*****/

  initializePointStoreAdmin() {
    this.pointStoreProductEditObj.landingPageView = this.pointStoreProductService.getNewPointStoreProductLandingPage();
    this.pointStoreProductEditObj.pointStoreProductFilter = this.pointStoreProductFilterService.getNewFilter();
    this.pointStoreProductEditObj.landingListToolbar = this.pointStoreProductLandingService.getNewLandingListToolbar();
  }

  getNewPointStoreProduct() {
    this.pointStoreProductEditObj.originalPointStoreProduct = this.pointStoreProductService.getNewPointStoreProduct();
    this.pointStoreProductEditObj.settingPointStoreProduct = this.pointStoreProductService.getNewPointStoreProductSetting();
    this.copyOriginalToModified();
  }

  setEditPointStoreProduct(pointStoreProduct) {
    pointStoreProduct.hasModifiedHighlight = false;
    this.pointStoreProductEditObj.originalPointStoreProduct = angular.copy(pointStoreProduct);
    this.copyOriginalToModified();
    this.loadSettingPointStoreObject();
    //pointStoreProductEditFactory.syncPointStoreProductGroupListUpdate();
    this.pointStoreProductEditObj.modifiedPointStoreProduct.imageString = [];
    if (pointStoreProduct.VariationsData == null) {
      this.pointStoreProductEditObj.modifiedPointStoreProduct.VariationsData = [
        { "id": 1 },
        { "id": 2 }
      ]
    } else {
      for (let i = 0; i < pointStoreProduct.VariationsData.length; i++) {
        this.pointStoreProductEditObj.modifiedPointStoreProduct.VariationsData[i].id = i + 1;
      }
    }
  }

  /*PointStoreCollection*/
  async LoadPointStoreProducts() {
    /*if (this.pointStoreProductEditObj.collection.isLoaded) { 
      return true;
    } check this one *****/
    try {
      let response: any = await this.loadPointStoreProduct();
      //if (response.status_code == 200) {
      if (response != null) {
        this.pointStoreProductEditObj.collection.isLoaded = true;
        this.pointStoreProductEditObj.collection.originalData = response;
        this.sortPointStoreProductCollection();
        this.setVariationTypeList();
        this.setUpgLoad(false);
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Products: " + error?.message);
    }

  }

  pushPointStoreProductToCollection() {
    if (this.pointStoreProductEditObj.modifiedPointStoreProduct.isNew) {
      this.pointStoreProductEditObj.modifiedPointStoreProduct.hasModifiedHighlight = true;
      this.pointStoreProductEditObj.collection.originalData.push(angular.copy(this.pointStoreProductEditObj.modifiedPointStoreProduct));
      this.sortPointStoreProductCollection();
    }
    else {
      let index = -1;
      let savedProduct = this.pointStoreProductEditObj.modifiedPointStoreProduct;
      //savedProduct.hasModifiedHighlight = true;
      let originalCollection = this.pointStoreProductEditObj.collection.originalData;
      for (let i = 0; i < originalCollection.length; i++) {
        if (originalCollection[i].PointStoreProductID == savedProduct.PointStoreProductID) {
          index = i;
          break;
        }
      }
      if (index > -1) {
        angular.copy(savedProduct, this.pointStoreProductEditObj.collection.originalData[index]);
        this.sortPointStoreProductCollection();
      }
    }
  }

  resetAddEditUploader() {
    angular.element(document.querySelector('.pointStoreUploadInput')).val(""); /****check this one, does it work? */
  }

  sortPointStoreProductCollection() {
    //I found a issue with the new cxone modal, when the modal is closed and originalData is null, there is a exception with the "sort" because this element is null
    if (this.pointStoreProductEditObj.collection.originalData == null) {
      return;
    }
    this.pointStoreProductEditObj.collection.originalData.sort((a, b) => {
      if (a.Title.toLowerCase() < b.Title.toLowerCase()) return -1;
      if (a.Title.toLowerCase() > b.Title.toLowerCase()) return 1;
      return 0;
    });

  if (!this.config.isCxOne) {
      //pull all products that have the hasModifiedHighlight flag (ones that are new or modified) out
      let highlights = this.pointStoreProductEditObj.collection.originalData.filter((item) => { if (item.hasModifiedHighlight) return true; });

      //Remove all highlighted items from list
      this.pointStoreProductEditObj.collection.originalData = this.pointStoreProductEditObj.collection.originalData.filter((item) => { if (!item.hasModifiedHighlight) return true; });

      //insert the items back into the front of the array
      for (let i = highlights.length - 1; i >= 0; i--) {
        this.pointStoreProductEditObj.collection.originalData.splice(0, 0, highlights[i]);
      }
    }
  }

  setVariationTypeList() {
    this.pointStoreProductEditObj.collection.originalData.forEach((currentValue, index, array) => {
      if (currentValue.VariationName != null && currentValue.VariationName != "" && this.pointStoreProductEditObj.variationTypes.indexOf(currentValue.VariationName) === -1) {
        this.pointStoreProductEditObj.variationTypes.push(currentValue.VariationName);
      }
    });

    //formatted variationTypes list
    this.pointStoreProductEditObj.variationTypesList = this.pointStoreProductEditObj.variationTypes.map((variation, index) => ({
      id: index + 1,
      name: variation,
    }));
  }

  removePointStoreProductObjFromCollection() {
    this.pointStoreProductEditObj.collection.originalData.splice(this.pointStoreProductEditObj.pointStoreProductCollection.index, 1);
  }

  setUpgLoad(bool) {
    this.pointStoreUtilityService.setUpgLoad(bool);
  }

  copyOriginalToModified() {
    this.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(this.pointStoreProductEditObj.originalPointStoreProduct);
  }

  copyModifiedToOriginal() {
    this.pointStoreProductEditObj.originalPointStoreProduct = angular.copy(this.pointStoreProductEditObj.modifiedPointStoreProduct);
  }

  setNullPointStoreProduct() {
    this.pointStoreProductEditObj.modifiedPointStoreProduct = null;
    this.pointStoreProductEditObj.originalPointStoreProduct = null;
  }

  duplicateOriginalToModified() {
    this.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(this.pointStoreProductEditObj.originalPointStoreProduct);
    this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductID = null;
    this.pointStoreProductEditObj.modifiedPointStoreProduct.Title += " Copy";
  }

  /*PointStore CSS*/
  getPointStoreProductCSSCarousel() {
    let css = '';
    let setting = angular.copy(this.pointStoreProductEditObj.settingPointStoreProduct);
    let settingCSS = angular.copy(this.pointStoreProductEditObj.pointStoreProductCSS);

    if (setting != null && settingCSS != null) {
      if (setting.Carousel && setting.FeaturedProduct && setting.Sale) css = settingCSS[0].name;
      else if (setting.Carousel && setting.FeaturedProduct) css = settingCSS[1].name;
      else if (setting.Carousel && setting.Sale) css = settingCSS[3].name;
      else if (setting.Carousel) css = settingCSS[2].name;

      else if (setting.FeaturedProduct && setting.Sale) css = settingCSS[4].name;
      else if (setting.FeaturedProduct) css = settingCSS[5].name;
      else if (!setting.Carousel && !setting.FeaturedProduct) css = settingCSS[7].name;
    }
    return css;
  }

  getPointStoreProductCSSSale() {
    let css = '';
    let setting = angular.copy(this.pointStoreProductEditObj.settingPointStoreProduct)
    let settingCSS = angular.copy(this.pointStoreProductEditObj.pointStoreProductCSS);

    if (setting != null && settingCSS != null) {
      if (setting.Sale) css = settingCSS[6].name;
      else if (!setting.Sale) css = settingCSS[8].name;
    }
    return css;
  }

  getPointStoreProductCSSSort(i) {
    let css = '';
    let setting = angular.copy(this.pointStoreProductEditObj.settingPointStoreProduct)
    let settingCSS = angular.copy(this.pointStoreProductEditObj.pointStoreProductCSS);

    if (this.pointStoreProductEditObj.pointStoreProductSort[i].sort == null) css = settingCSS[9].name;
    else if (this.pointStoreProductEditObj.pointStoreProductSort[i].sort == true) css = settingCSS[10].name;
    else if (this.pointStoreProductEditObj.pointStoreProductSort[i].sort == false) css = settingCSS[11].name;

    return css;
  }

  /*LandingPage*/
  setThumbnailView() {
    this.pointStoreProductEditObj.landingPageView.thumbnail = true;
    this.pointStoreProductEditObj.landingPageView.list = false;
  }

  setListView() {
    this.pointStoreProductEditObj.landingPageView.thumbnail = false;
    this.pointStoreProductEditObj.landingPageView.list = true;
  }

  setSortList(i) {
    if (this.pointStoreProductEditObj.pointStoreProductSort[i].sort == null) {
      this.pointStoreProductEditObj.pointStoreProductSort[i].sort = true;
      this.pointStoreProductEditObj.sortReverse = false;
    } else if (this.pointStoreProductEditObj.pointStoreProductSort[i].sort == true) {
      this.pointStoreProductEditObj.pointStoreProductSort[i].sort = false;
      this.pointStoreProductEditObj.sortReverse = true;
    } else {
      this.pointStoreProductEditObj.pointStoreProductSort[i].sort = null;
      this.pointStoreProductEditObj.sortReverse = "";
    }

    for (let j = 0; j < this.pointStoreProductEditObj.pointStoreProductSort.length; j++) {
      if (j != i) { this.pointStoreProductEditObj.pointStoreProductSort[j].sort = null; }
      else { this.pointStoreProductEditObj.sortBy = this.pointStoreProductEditObj.pointStoreProductSort[j].name; }
    }
  }

  setFilterMatches(item) {
    if (item != null && item.hasModifiedHighlight && !this.isFilterActive()) return true; //return true if hasModifiedHighlight (new or edited item)

    let match_category_filter = false;
    let match_sub_category_filter = false;
    let match_title_filter = false;

    let match_sale = false;
    let match_carousel = false;
    let match_feature_product = false;

    let isProductRemoved = item.IsDeletedChecked;
    
    //get the all string based on the localization
    const allLabel:string = this.cvLocalizationService.getCachedText('MarketPlace', 'All', 'All')

    //Category check
    if (!(this.pointStoreProductEditObj.pointStoreProductFilter.Category == '')) {
      if (item.Category.toLowerCase().indexOf(this.pointStoreProductEditObj.pointStoreProductFilter.Category.toLowerCase()) > -1 ||
        this.pointStoreProductEditObj.pointStoreProductFilter.Category.toLowerCase() == allLabel.toLowerCase()) {
        match_category_filter = true;
      }
    }
    else
      match_category_filter = true;

    //Sub-category check
    if (!(this.pointStoreProductEditObj.pointStoreProductFilter.SubCategory == '')) {
      if (item.SubCategory.toLowerCase().indexOf(this.pointStoreProductEditObj.pointStoreProductFilter.SubCategory.toLowerCase()) > -1 ||
        this.pointStoreProductEditObj.pointStoreProductFilter.SubCategory.toLowerCase() == allLabel.toLowerCase()) {
        match_sub_category_filter = true;
      }
    }
    else
      match_sub_category_filter = true;

    //Title match
    if (!(this.pointStoreProductEditObj.pointStoreProductFilter.Title == '')) {
      if (item.Title != null) {
        if (item.Title.toLowerCase().indexOf(this.pointStoreProductEditObj.pointStoreProductFilter.Title.toLowerCase()) > -1) {
          match_title_filter = true;
        }
      }

      //Don't think we need to include 
      //if (item.Description.toLowerCase().indexOf(this.pointStoreProductEditObj.pointStoreProductFilter.Title.toLowerCase()) > -1) {
      //    match_title_filter = true;
      //}
    }
    else
      match_title_filter = true;

    //Boolean checks            
    if ((this.pointStoreProductEditObj.pointStoreProductFilter.Sale && item.Sale > 0 && item.SaleStart != null) || !this.pointStoreProductEditObj.pointStoreProductFilter.Sale) match_sale = true;
    if ((this.pointStoreProductEditObj.pointStoreProductFilter.Feature && item.FeatureStart != null) || !this.pointStoreProductEditObj.pointStoreProductFilter.Feature) match_feature_product = true;
    if ((this.pointStoreProductEditObj.pointStoreProductFilter.Carousel && item.CarouselStart != null) || !this.pointStoreProductEditObj.pointStoreProductFilter.Carousel) match_carousel = true;

    if (match_category_filter &&
      match_sub_category_filter &&
      match_title_filter &&
      match_sale &&
      match_feature_product &&
      match_carousel &&
      //match_groupSelector &&
      isProductRemoved == false) {
      return true;
    }

    item.IsChecked = false; /*Set to false when item no longer shows in list*/
    return false;
  }

  clearFilter() {
    this.pointStoreProductEditObj.pointStoreProductFilter.Category = '';
    this.pointStoreProductEditObj.pointStoreProductFilter.SubCategory = '';
    this.pointStoreProductEditObj.pointStoreProductFilter.Title = '';

    this.pointStoreProductEditObj.pointStoreProductFilter.Product = null;
    this.pointStoreProductEditObj.pointStoreProductFilter.Carousel = null;
    this.pointStoreProductEditObj.pointStoreProductFilter.ProductFeature = null;
    this.pointStoreProductEditObj.pointStoreProductFilter.Sale = null;
    this.pointStoreProductEditObj.pointStoreProductFilter.All = null;

    this.pointStoreProductEditObj.pointStoreProductFilter.ProductStart = null;
    this.pointStoreProductEditObj.pointStoreProductFilter.ProductEnd = null;
  }

  /*LandingPage List View*/
  countSelected() {
    if (this.pointStoreProductEditObj.collection.originalData != undefined) {
      return this.pointStoreProductEditObj.collection.originalData.filter((p) => {
        return p.IsChecked == true; /***** thiw was item for some reason... */
      }).count;
    } else {
      return 0;
    }
  }

  setSelectedAll() {
    if (this.pointStoreProductEditObj.collection.originalData != undefined) {
      for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
        if (this.setFilterMatches(this.pointStoreProductEditObj.collection.originalData[i])) {
          this.pointStoreProductEditObj.collection.originalData[i].IsChecked = this.pointStoreProductEditObj.landingListToolbar.selectAll;
        }
      }
    }
  }

  deSelectedAll() {
    if (this.pointStoreProductEditObj.collection.originalData != undefined) {
      for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
      }
    }

    //(For PointStoreProductLandingList View) Enable all the checkboxes, make sure the "Select All" checkbox is unchecked, too.
    //$('#ProductListTableContainer').find(':checkbox').prop('disabled', false);
    //$('#ProductListSelectAllCheckbox').find(':checkbox').prop('checked', false);
    let tableContainer = $('#ProductListTableContainer');
    if (tableContainer != null) {
      tableContainer.find(':checkbox').prop('disabled', false);
    }

    let selectAllCheckbox = $('#ProductListSelectAllCheckbox');
    if (selectAllCheckbox != null) {
      selectAllCheckbox.find(':checkbox').prop('checked', false);
    }
  }

  evaluateMultiSelectedProduct() {
    if (this.pointStoreProductEditObj.collection.originalData != undefined) {
      let newObj = this.pointStoreProductEditObj.collection.originalData.filter((item) => {
        if (item.IsChecked != undefined) {
          return item.IsChecked;
        }
        return false;
      });

      if (newObj.length > 1) {
        //pointStoreProductEditFactory.clearToolbarActions();
        return true;
      }
    }
    return false;
  }

  evaluateSelectedProduct() {
    if (this.pointStoreProductEditObj.collection.originalData != undefined) {
      let newObj = this.pointStoreProductEditObj.collection.originalData.filter((item) => {
        if (item.IsChecked != undefined) {
          return item.IsChecked;
        }
        return false;
      });

      if (newObj.length == 1) {
        return true;
      }
    }
    return false;
  }

  clearToolbarActions(position = null) {
    for (let i = 0; i < this.pointStoreProductEditObj.landingListToolbar.toolbarAction.length; i++) {
      this.pointStoreProductEditObj.landingListToolbar.toolbarAction[i].value = false;
    }
    this.setToolbarAction(position, true);
  }

  setToolbarAction(position, value) {
    if (position != undefined)
      this.pointStoreProductEditObj.landingListToolbar.toolbarAction[position].value = value;
  }

  getListViewDisplayOptionCSS(product, value) {
    if (product == null || product == undefined) return false;

    let currentDate = new Date();
    let currentProduct = angular.copy(product);
    currentDate.setHours(0, 0, 0, 0);

    if ((currentProduct.CarouselStart != null || currentProduct.CarouselEnd != null) && value == 0) {

      if (currentProduct.CarouselEnd != null) {

        let startDate = new Date(currentProduct.CarouselStart);
        let endDate = new Date(currentProduct.CarouselEnd);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        //currentProduct.CarouselStart.setHours(0, 0, 0, 0);
        //currentProduct.CarouselEnd.setHours(0, 0, 0, 0);
        if (startDate <= currentDate && endDate >= currentDate) {
          return true;
        }
      } else if (currentProduct.CarouselStart != null) {
        let startDate = new Date(currentProduct.CarouselStart);
        startDate.setHours(0, 0, 0, 0);

        //currentProduct.CarouselStart.setHours(0, 0, 0, 0);
        if (startDate <= currentDate) {
          return true;
        }
      }
    }
    if ((currentProduct.FeatureStart != null || currentProduct.FeatureEnd != null) && value == 1) {
      if (currentProduct.FeatureEnd != null) {
        let startDate = new Date(currentProduct.FeatureStart);
        let endDate = new Date(currentProduct.FeatureEnd);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        //currentProduct.FeatureStart.setHours(0, 0, 0, 0);
        //currentProduct.FeatureEnd.setHours(0, 0, 0, 0);
        if (startDate <= currentDate && endDate >= currentDate) {
          return true;
        }
      } else if (currentProduct.FeatureStart != null) {
        let startDate = new Date(currentProduct.FeatureStart);
        startDate.setHours(0, 0, 0, 0);

        //currentProduct.FeatureStart.setHours(0, 0, 0, 0);
        if (startDate <= currentDate) {
          return true;
        }
      }
    }
    if ((currentProduct.SaleStart != null || currentProduct.SaleEnd != null) && value == 2) {
      if (currentProduct.SaleEnd != null) {
        let startDate = new Date(currentProduct.SaleStart);
        let endDate = new Date(currentProduct.SaleEnd);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        //currentProduct.SaleStart.setHours(0, 0, 0, 0);
        //currentProduct.SaleEnd.setHours(0, 0, 0, 0);
        if (startDate <= currentDate && endDate >= currentDate) {
          return true;
        }
      } else if (currentProduct.SaleStart != null) {
        let startDate = new Date(currentProduct.SaleStart);
        startDate.setHours(0, 0, 0, 0);

        //currentProduct.SaleStart.setHours(0, 0, 0, 0);
        if (startDate <= currentDate) {
          return true;
        }
      }
    }
    return false;
  }

  getTotalAssignments(product) {
    if (product == null || product == undefined) return -1000;

    for (let i = 0; i < product.PointStoreProductAssignments.length; i++) {
      if (product.PointStoreProductAssignments[i].EmpGroupLevel == 5 && product.PointStoreProductAssignments[i].EmpGroupID == 0) {
        let message = this.getLocalizationString("All", "All");
        return message;
      }
    }
    return product.PointStoreProductAssignments.length;
  }

  setPointStoreProductFromListView(product) {
    this.pointStoreProductEditObj.originalPointStoreProduct = angular.copy(product);
    this.copyOriginalToModified();
    this.pointStoreProductEditObj.modifiedPointStoreProduct.imageString = [];
  }

  clearToolBarIfMultiSelectedProductActive() {
    if (this.evaluateMultiSelectedProduct()) {
      this.clearToolbarActions();
      this.clickCancelListView();
      this.setNullPointStoreProduct();
    }
  }

  clickAddPointStoreProductToListView() {
    let newObj: any = this.getNewPointStoreProduct();
    newObj.IsChecked = true;
    newObj.ProductStart = null;
    newObj.ProductEnd = null;
    this.setPointStoreProductFromListView(newObj);

    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
    }
  }

  setSelectedPointStoreProductFromListView() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked) {
        this.setPointStoreProductFromListView(this.pointStoreProductEditObj.collection.originalData[i]);

        let product = angular.copy(this.pointStoreProductEditObj.modifiedPointStoreProduct);
        if (product.CarouselStart != null || product.CarouselEnd != null) { this.pointStoreProductEditObj.modifiedPointStoreProduct.IsCarouselChecked = true; }
        if (product.FeatureStart != null || product.FeatureEnd != null) { this.pointStoreProductEditObj.modifiedPointStoreProduct.IsFeaturedChecked = true; }
        if (product.SaleStart != null || product.SaleEnd != null) { this.pointStoreProductEditObj.modifiedPointStoreProduct.IsOnSaleChecked = true; }

        this.loadSettingPointStoreObject();
        break;
      }
    }
  }


  clickCancelListView() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.originalPointStoreProduct != null) {
        if (this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID == this.pointStoreProductEditObj.originalPointStoreProduct.PointStoreProductID) {
          this.pointStoreProductEditObj.collection.originalData[i] = angular.copy(this.pointStoreProductEditObj.originalPointStoreProduct);
          break;
        }
      }
    }
    this.clearToolbarActions();

    for (let i = this.pointStoreProductEditObj.collection.originalData.length - 1; i >= 0; i--) {
      if (this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID == 0) {
        this.pointStoreProductEditObj.collection.originalData.splice(i, 1);
      }
    }
  }
  isOriginalEqualToModified() {
    return angular.equals(this.pointStoreProductEditObj.originalPointStoreProduct, this.pointStoreProductEditObj.modifiedPointStoreProduct);
  }

  savePointStoreProductFromDisplayOptions() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked) {
        this.pointStoreProductEditObj.collection.originalData[i].CarouselStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselStart;
        this.pointStoreProductEditObj.collection.originalData[i].CarouselEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselEnd;

        this.pointStoreProductEditObj.collection.originalData[i].FeatureStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureStart;
        this.pointStoreProductEditObj.collection.originalData[i].FeatureEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureEnd;

        this.pointStoreProductEditObj.collection.originalData[i].SaleStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleStart;
        this.pointStoreProductEditObj.collection.originalData[i].SaleEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleEnd;

        this.pointStoreProductEditObj.collection.originalData[i].CarouselStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselStart_ForView;
        this.pointStoreProductEditObj.collection.originalData[i].CarouselEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselEnd_ForView;

        this.pointStoreProductEditObj.collection.originalData[i].FeatureStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureStart_ForView;
        this.pointStoreProductEditObj.collection.originalData[i].FeatureEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureEnd_ForView;

        this.pointStoreProductEditObj.collection.originalData[i].SaleStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleStart_ForView;
        this.pointStoreProductEditObj.collection.originalData[i].SaleEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleEnd_ForView;

        this.pointStoreProductEditObj.collection.originalData[i].Sale = this.pointStoreProductEditObj.modifiedPointStoreProduct.Sale;
        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
        break;
      }
    }
  }

  saveMultiEditList(isLayoutOptions) {
    let modifiedProducts = this.pointStoreProductEditObj.collection.originalData.filter((product) => { return product.IsChecked; }).length;
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked) {

        if (isLayoutOptions) {
          this.pointStoreProductEditObj.collection.originalData[i].CarouselStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselStart;
          this.pointStoreProductEditObj.collection.originalData[i].CarouselStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselStart_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].CarouselEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselEnd;
          this.pointStoreProductEditObj.collection.originalData[i].CarouselEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.CarouselEnd_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].FeatureStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureStart;
          this.pointStoreProductEditObj.collection.originalData[i].FeatureStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureStart_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].FeatureEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureEnd;
          this.pointStoreProductEditObj.collection.originalData[i].FeatureEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.FeatureEnd_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].SaleStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleStart;
          this.pointStoreProductEditObj.collection.originalData[i].SaleStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleStart_ForView;
          this.pointStoreProductEditObj.collection.originalData[i].Sale = this.pointStoreProductEditObj.modifiedPointStoreProduct.Sale;

          this.pointStoreProductEditObj.collection.originalData[i].SaleEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleEnd;
          this.pointStoreProductEditObj.collection.originalData[i].SaleEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.SaleEnd_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].IsCarouselChecked = this.pointStoreProductEditObj.collection.originalData[i].CarouselStart != null;
          this.pointStoreProductEditObj.collection.originalData[i].IsFeaturedChecked = this.pointStoreProductEditObj.collection.originalData[i].FeatureStart != null;
          this.pointStoreProductEditObj.collection.originalData[i].IsOnSaleChecked = this.pointStoreProductEditObj.collection.originalData[i].SaleStart != null;

          if (modifiedProducts > 1) {
            if (this.pointStoreProductEditObj.collection.originalData[i].HasProductVariations) {
              for (let j = 0; j < this.pointStoreProductEditObj.collection.originalData[i].VariationsData.length; j++) {
                if (this.pointStoreProductEditObj.modifiedPointStoreProduct.IsOnSaleChecked && this.pointStoreProductEditObj.modifiedPointStoreProduct.Sale != null)
                  this.pointStoreProductEditObj.collection.originalData[i].VariationsData[j].VariationOnSale = true;
                else
                  this.pointStoreProductEditObj.collection.originalData[i].VariationsData[j].VariationOnSale = false;
              }
            }
          } else {
            if (this.pointStoreProductEditObj.modifiedPointStoreProduct.HasProductVariations) {
              for (let j = 0; j < this.pointStoreProductEditObj.modifiedPointStoreProduct.VariationsData.length; j++) {
                this.pointStoreProductEditObj.collection.originalData[i].VariationsData[j].VariationOnSale = this.pointStoreProductEditObj.modifiedPointStoreProduct.VariationsData[j].VariationOnSale;
              }
            }
          }
        } else {
          if (this.pointStoreProductEditObj.modifiedPointStoreProduct.Category != null)
            this.pointStoreProductEditObj.collection.originalData[i].Category = this.pointStoreProductEditObj.modifiedPointStoreProduct.Category;

          if (this.pointStoreProductEditObj.modifiedPointStoreProduct.SubCategory != null)
            this.pointStoreProductEditObj.collection.originalData[i].SubCategory = this.pointStoreProductEditObj.modifiedPointStoreProduct.SubCategory;

          if (this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart != null) {
            this.pointStoreProductEditObj.collection.originalData[i].ProductStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart;
            this.pointStoreProductEditObj.collection.originalData[i].ProductStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart_ForView;
          }

          if (this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd != null) {
            this.pointStoreProductEditObj.collection.originalData[i].ProductEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd;
            this.pointStoreProductEditObj.collection.originalData[i].ProductEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd_ForView;
          }
        }

        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
      }
    }
    this.setNullPointStoreProduct();
  }

  saveEditList(result) {
    if (this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductID == 0) {
      result.IsChecked = false;
      this.pointStoreProductEditObj.collection.originalData.push(angular.copy(result));
    } else {
      for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {

        if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked == true) {
          this.pointStoreProductEditObj.collection.originalData[i].ProductStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart;
          this.pointStoreProductEditObj.collection.originalData[i].ProductEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd;

          this.pointStoreProductEditObj.collection.originalData[i].ProductStart_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart_ForView;
          this.pointStoreProductEditObj.collection.originalData[i].ProductEnd_ForView = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd_ForView;

          this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;

          this.pointStoreProductEditObj.collection.originalData[i].CompanyID = result.CompanyID;
          this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID = result.PointStoreProductID;
          this.pointStoreProductEditObj.collection.originalData[i].ProductImageID = result.ProductImageID;

          this.pointStoreProductEditObj.collection.originalData[i].Title = this.pointStoreProductEditObj.modifiedPointStoreProduct.Title;
          this.pointStoreProductEditObj.collection.originalData[i].Description = this.pointStoreProductEditObj.modifiedPointStoreProduct.Description;
          this.pointStoreProductEditObj.collection.originalData[i].Category = this.pointStoreProductEditObj.modifiedPointStoreProduct.Category;
          this.pointStoreProductEditObj.collection.originalData[i].SubCategory = this.pointStoreProductEditObj.modifiedPointStoreProduct.SubCategory;

          this.pointStoreProductEditObj.collection.originalData[i].Price = this.pointStoreProductEditObj.modifiedPointStoreProduct.Price;
          this.pointStoreProductEditObj.collection.originalData[i].Quantity = this.pointStoreProductEditObj.modifiedPointStoreProduct.Quantity;

          break;
        }
      }
    }
    this.setNullPointStoreProduct();
  }

  saveAddCopyList(result) {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked == true) {
        this.pointStoreProductEditObj.collection.originalData[i].ProductStart = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductStart;
        this.pointStoreProductEditObj.collection.originalData[i].ProductEnd = this.pointStoreProductEditObj.modifiedPointStoreProduct.ProductEnd;

        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
        break;
      }
    }
    this.setNullPointStoreProduct();
  }

  saveAssignmentList() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked == true) {
        this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductAllAssignments

        this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductAllAssignments = angular.copy(this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductAllAssignments);
        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
        break;
      }
    }
    this.setNullPointStoreProduct();
  }

  saveMultiAssignmentList() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked == true) {
        this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductAllAssignments = angular.copy(this.pointStoreProductEditObj.modifiedPointStoreProduct.PointStoreProductAllAssignments);
        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
      }
    }
    this.setNullPointStoreProduct();
  }

  saveImageFromListView(product) {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID == this.pointStoreProductEditObj.originalPointStoreProduct.PointStoreProductID) {
        this.pointStoreProductEditObj.collection.originalData[i].imageString = this.pointStoreProductEditObj.modifiedPointStoreProduct.imageString;
        this.pointStoreProductEditObj.collection.originalData[i].ProductImageID = product.ProductImageID;
        this.setNullPointStoreProduct();
        this.pointStoreProductEditObj.modifiedPointStoreProduct = angular.copy(product);
        this.copyModifiedToOriginal();
        this.pushPointStoreProductToCollection(); /*this.pushPointStoreProductToCollection(product);**********8 */
        break;
      }
    }
  }

  setNewPointSToreProductForListView() {
    this.setPointStoreProductFromListView(this.getNewPointStoreProductForListView());
  }

  getNewPointStoreProductForListView() {
    let newObj: any = this.getNewPointStoreProduct();
    newObj.IsChecked = true;
    newObj.ProductStart = null;
    newObj.ProductEnd = null;
    return newObj;
  }

  removeIsCheckedPointStoreProduct() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked) {
        this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;
        this.pointStoreProductEditObj.collection.originalData[i].IsDeletedChecked = true;
        //this.pointStoreProductEditObj.collection.originalData[i].PointStoreProductID = 0;
      }
    }
    this.pointStoreProductEditObj.landingListToolbar.selectAll = false;
  }

  copyPointStoreProductFromListView() {
    for (let i = 0; i < this.pointStoreProductEditObj.collection.originalData.length; i++) {
      if (this.pointStoreProductEditObj.collection.originalData[i].IsChecked) {


        let message = this.LocalizationMarketManMessages["Copy"][0];


        let newObj = angular.copy(this.pointStoreProductEditObj.collection.originalData[i]);
        newObj.IsChecked = true;
        newObj.PointStoreProductID = 0;
        newObj.Title = message + " " + newObj.Title;
        //Added to Avoid carrying the orderes from the source product (ListView)
        newObj.QuantityOrdered = 0;
        //this.pointStoreProductEditObj.collection.originalData.push(newObj);

        this.setPointStoreProductFromListView(newObj);
        this.loadSettingPointStoreObject();

        // this.pointStoreProductEditObj.collection.originalData[i].IsChecked = false;

        // pointStoreProductEditFactory.clickAddPointStoreProductToListView()
        break;
      }
    }

  }

  ComputeSalePrice(product) {
    if (this.getListViewDisplayOptionCSS(product, 2)) {
      return Math.ceil(product.Price - ((product.Sale / 100.0) * product.Price));
    }
    return product.Price
  }

  /**
   * 
   * @returns boolean hasMatchingProperty
   */
  isFilterActive(): boolean {
    let hasMatchingProperty = true;

    let allLabel = this.getLocalizationString("All", "All");
    let filterObj = this.pointStoreProductEditObj.pointStoreProductFilter;

    //Checking product tags filter and search bar
    if ((!filterObj.Carousel && !filterObj.Feature && !filterObj.Sale) && (filterObj.Title == "")){
      //Checking default selectors value
      if((filterObj.Category == "" || filterObj.Category == allLabel) && ((filterObj.SubCategory == "" || filterObj.SubCategory == allLabel) || (filterObj.SubCategory.name == "" || filterObj.SubCategory.name == allLabel))){
        hasMatchingProperty = false;
      }
    }
    
    return hasMatchingProperty;
  }

  cleanFilters(){
    return this.pointStoreProductFilterService.getNewFilter();
  }

  getLocalizationString(key: string, defaultValue: string) {
    if (this.LocalizationMarket && this.LocalizationMarket.has(key))
        return this.LocalizationMarket.get(key);
    return defaultValue;
  }
}